import { useAuth } from '@/lib/auth';
import { User, Building2, Mail, FileText } from 'lucide-react';

export default function Account() {
  const { user } = useAuth();

  return (
    <div data-testid="account-page" className="min-h-screen">
      <div className="border-b border-black/10 bg-[#F8F9FA]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <p className="text-xs uppercase tracking-[0.2em] text-[#00A5FF] font-semibold mb-2">Mon compte</p>
          <h1 className="text-2xl sm:text-3xl font-extrabold text-[#111] tracking-tight">Informations du compte</h1>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="border border-black/10">
          <div className="p-6 space-y-4">
            <div className="flex items-start gap-3 pb-4 border-b border-black/5">
              <Building2 size={18} className="text-[#00A5FF] mt-0.5" />
              <div>
                <p className="text-xs uppercase tracking-wider text-black/40 font-semibold mb-0.5">Entreprise</p>
                <p className="text-sm font-bold text-[#111]">{user?.company_name}</p>
              </div>
            </div>
            <div className="flex items-start gap-3 pb-4 border-b border-black/5">
              <Mail size={18} className="text-[#00A5FF] mt-0.5" />
              <div>
                <p className="text-xs uppercase tracking-wider text-black/40 font-semibold mb-0.5">Email</p>
                <p className="text-sm text-[#111]">{user?.email}</p>
              </div>
            </div>
            <div className="flex items-start gap-3 pb-4 border-b border-black/5">
              <FileText size={18} className="text-[#00A5FF] mt-0.5" />
              <div>
                <p className="text-xs uppercase tracking-wider text-black/40 font-semibold mb-0.5">Numéro de TVA</p>
                <p className="text-sm text-[#111]">{user?.vat_number || 'Non renseigné'}</p>
              </div>
            </div>
            <div className="flex items-start gap-3 pb-4 border-b border-black/5">
              <User size={18} className="text-[#00A5FF] mt-0.5" />
              <div>
                <p className="text-xs uppercase tracking-wider text-black/40 font-semibold mb-0.5">Statut du compte</p>
                <p className="text-sm">
                  {user?.status === 'validated' && <span className="text-green-600 font-semibold">Validé</span>}
                  {user?.status === 'pending' && <span className="text-[#F5C400] font-semibold">En attente de validation</span>}
                  {user?.status === 'rejected' && <span className="text-[#E8231B] font-semibold">Rejeté</span>}
                </p>
              </div>
            </div>
            {user?.discount_percent > 0 && (
              <div className="flex items-start gap-3">
                <div className="w-[18px] h-[18px] bg-[#F5C400] rounded-sm flex items-center justify-center text-[#111] text-xs font-bold mt-0.5">%</div>
                <div>
                  <p className="text-xs uppercase tracking-wider text-black/40 font-semibold mb-0.5">Remise professionnelle</p>
                  <p className="text-sm font-bold text-[#111]">{user?.discount_percent}%</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
